<template>
  <div class="page">
    <!-- 查询区 -->
    <el-card class="card">
      <div slot="header" class="card-header">
        <span>设备管理</span>
        <el-button type="primary" icon="el-icon-plus" @click="openAdd">新增设备</el-button>
      </div>

      <el-form :inline="true" :model="query" class="query-form">
        <el-form-item label="关键字">
          <el-input
            v-model="query.keyword"
            placeholder="设备编号/设备名称/小区"
            clearable
            @keyup.enter.native="fetchList"
            style="width:260px;"
          />
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="全部" clearable style="width:140px;">
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="fetchList">查询</el-button>
          <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格区 -->
      <el-table
        :data="list"
        border
        stripe
        v-loading="loading"
        style="width:100%;"
      >
      <el-table-column prop="community_name" label="序号" width="140" />
        <el-table-column prop="device_code" label="设备编号" width="120" />
        <el-table-column prop="device_name" label="设备名称" min-width="180" />
        <el-table-column prop="address" label="设备地址" min-width="180" />
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="s">
            <el-tag :type="s.row.status === 1 ? 'success' : 'info'">
              {{ s.row.status === 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="remark" label="备注" min-width="140" />

        <!-- 投递口：hover 预览二维码；点击图片弹窗放大；下载按钮保持下载 -->
        <el-table-column label="投递口(系统自动4个)" min-width="260">
          <template slot-scope="s">
            <div class="bin-wrap">
              <el-popover
                v-for="b in (s.row.bins || [])"
                :key="b.id"
                placement="bottom"
                trigger="hover"
                popper-class="qr-popper"
              >
                <div class="qr-box">
                  <div class="qr-title">
                    {{ getQrTitle(s.row, b.garbage_type) }}
                  </div>

                  <div class="qr-img-wrap" v-if="b.qr_image_url">
                    <img
                      class="qr-img"
                      :src="b.qr_image_url"
                      alt="二维码"
                      @click.stop="openQrPreview(s.row, b.garbage_type, b.qr_image_url)"
                      title="点击放大预览"
                    />
                  </div>
                  <div v-else class="qr-empty">暂无二维码</div>

                  <div class="qr-actions">
                    <el-button
                      v-if="b.qr_image_url"
                      size="mini"
                      type="primary"
                      icon="el-icon-download"
                      @click="downloadQr(b.qr_image_url, s.row.device_code, b.garbage_type)"
                    >
                      下载二维码
                    </el-button>
                  </div>

                  <div class="qr-tip" v-if="b.qr_image_url">
                    说明：鼠标悬停预览，点击二维码可放大，下载按钮保持下载
                  </div>
                </div>

                <!-- 触发元素：标签（点击下载） -->
                <el-tag
                  slot="reference"
                  size="mini"
                  class="bin-tag"
                  :class="{ disabled: !b.qr_image_url }"
                  @click.stop="b.qr_image_url && downloadQr(b.qr_image_url, s.row.device_code, b.garbage_type)"
                >
                  {{ garbageText(b.garbage_type) }}
                </el-tag>
              </el-popover>

              <span v-if="!(s.row.bins && s.row.bins.length)" class="empty">-</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="创建时间" width="160">
          <template slot-scope="s">
            {{ formatTime(s.row.created_at) }}
          </template>
        </el-table-column>

        <!-- <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="s">
            <el-button type="text" @click="openEdit(s.row)">编辑</el-button>
            <el-button type="text" style="color:#ef4444;" @click="onDelete(s.row)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <!-- 分页 -->
      <div class="pager">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes"
          :total="total"
          :current-page="page"
          :page-size="pageSize"
          @current-change="p => { page = p; fetchList() }"
          @size-change="s => { pageSize = s; page = 1; fetchList() }"
        />
      </div>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogMode === 'add' ? '新增设备' : '编辑设备'"
      :visible.sync="dialogVisible"
      width="680px"
      @closed="onDialogClosed"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="设备编号" prop="device_code" v-if="dialogMode==='add'">
          <el-input v-model="form.device_code" placeholder="例如：RJ001" />
        </el-form-item>
        

        <el-form-item label="设备编号" v-else>
          <el-input v-model="form.device_code" disabled />
        </el-form-item>

        <el-form-item label="序号" prop="community_name">
          <el-input v-model="form.community_name" placeholder="例如：1" />
        </el-form-item>

        <el-form-item label="设备名称" prop="device_name">
          <el-input v-model="form.device_name" placeholder="例如：锦绣小区1号回收站" />
        </el-form-item>

        

        <el-form-item label="设备地址" prop="address">
          <el-input v-model="form.address" placeholder="例如：锦绣小区东门" />
        </el-form-item>

        <el-form-item label="旧系统设备编号" prop="old_device_code">
          <el-input v-model="form.old_device_code" placeholder="可选：旧系统编号" />
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" :rows="3" v-model="form.remark" placeholder="备注信息" />
        </el-form-item>

        <el-alert
          title="说明：新增设备后系统会自动生成4个投递口：废纸/塑料/衣物/废铁"
          type="info"
          :closable="false"
          show-icon
        />
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="onSubmit">
          {{ dialogMode === 'add' ? '确认新增' : '确认保存' }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 二维码放大弹窗 -->
    <el-dialog
  title="二维码预览"
  :visible.sync="previewVisible"
  width="60%"
  top="10vh"
  append-to-body
  @closed="onPreviewClosed"
>
      <div class="preview-board" v-if="previewImageUrl">
        <div class="preview-title">{{ previewTitle }}</div>

        <div class="preview-img-wrap">
          <img
            class="preview-img"
            :src="previewImageUrl"
            alt="二维码大图"
          />
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="previewVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDeviceList,
  createDevice,
  updateDevice,
  deleteDevice
} from '@/api/device'

export default {
  name: 'DeviceList',
  data() {
    return {
      loading: false,
      saving: false,

      query: {
        keyword: '',
        status: undefined
      },
      page: 1,
      pageSize: 20,
      total: 0,
      list: [],

      dialogVisible: false,
      dialogMode: 'add', // add | edit
      currentId: null,

      previewVisible: false,
      previewTitle: '',
      previewImageUrl: '',

      form: {
        device_code: '',
        device_name: '',
        community_name: '',
        address: '',
        old_device_code: '',
        status: 1,
        remark: ''
      },

      rules: {
        device_code: [{ required: true, message: '请输入设备编号', trigger: 'blur' }],
        device_name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        community_name: [{ required: true, message: '请输入小区名称', trigger: 'blur' }],
        address: [{ required: true, message: '请输入设备地址', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    garbageText(v) {
      const map = {
        1: '废纸',
        2: '塑料',
        3: '衣物',
        4: '废铁'
      }
      return map[v] || `未知(${v})`
    },

    garbageUyghurText(v) {
      const map = {
        1: 'قەغەز',
        2: 'سۇلىياۋ',
        3: 'كىيىم',
        4: 'مىتال'
      }
      return map[v] || ''
    },

    getQrTitle(row, garbageType) {
      const deviceName = row.device_name || row.device_code || '-'
      const zhName = this.garbageText(garbageType)
      const ugName = this.garbageUyghurText(garbageType)
      return `${deviceName} · ${zhName} · ${ugName}`
    },

    openQrPreview(row, garbageType, imageUrl) {
      if (!imageUrl) return
      this.previewTitle = this.getQrTitle(row, garbageType)
      this.previewImageUrl = imageUrl
      this.previewVisible = true
    },

    onPreviewClosed() {
      this.previewTitle = ''
      this.previewImageUrl = ''
    },

    formatTime(ts) {
      if (!ts) return '-'
      const d = new Date(ts * 1000)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },

    // 下载二维码：优先 fetch blob（跨域允许时），失败再降级 a 标签直链
    async downloadQr(url, deviceCode, garbageType) {
      const nameMap = {
        1: '废纸',
        2: '塑料',
        3: '衣物',
        4: '废铁'
      }
      const typeName = nameMap[garbageType] || `type${garbageType}`
      const filename = `${deviceCode}_${typeName}_二维码.png`

      try {
        const resp = await fetch(url, { mode: 'cors' })
        const blob = await resp.blob()
        const blobUrl = window.URL.createObjectURL(blob)

        const a = document.createElement('a')
        a.href = blobUrl
        a.download = filename
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)

        window.URL.revokeObjectURL(blobUrl)
      } catch (e) {
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
    },

    async fetchList() {
      this.loading = true
      try {
        const params = {
          page: this.page,
          page_size: this.pageSize
        }
        if (this.query.keyword) params.keyword = this.query.keyword.trim()
        if (this.query.status === 0 || this.query.status === 1) params.status = this.query.status

        const res = await getDeviceList(params)
        this.list = res.items || []
        this.total = res.total || 0
      } finally {
        this.loading = false
      }
    },

    reset() {
      this.query = { keyword: '', status: undefined }
      this.page = 1
      this.fetchList()
    },

    openAdd() {
      this.dialogMode = 'add'
      this.currentId = null
      this.dialogVisible = true
      this.form = {
        device_code: '',
        device_name: '',
        community_name: '',
        address: '',
        old_device_code: '',
        status: 1,
        remark: ''
      }
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },

    openEdit(row) {
      this.dialogMode = 'edit'
      this.currentId = row.id
      this.dialogVisible = true

      this.form = {
        device_code: row.device_code || '',
        device_name: row.device_name || '',
        community_name: row.community_name || '',
        address: row.address || '',
        old_device_code: row.old_device_code || row.device_code || '',
        status: row.status ?? 1,
        remark: row.remark || ''
      }
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },

    onDialogClosed() {
      this.saving = false
    },

    onSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          if (this.dialogMode === 'add') {
            await createDevice({
              device_code: this.form.device_code.trim(),
              device_name: this.form.device_name.trim(),
              community_name: this.form.community_name.trim(),
              address: this.form.address.trim(),
              old_device_code: (this.form.old_device_code || '').trim() || this.form.device_code.trim(),
              status: this.form.status,
              remark: (this.form.remark || '').trim()
            })
            this.$message.success('新增成功')
          } else {
            await updateDevice(this.currentId, {
              device_name: this.form.device_name.trim(),
              community_name: this.form.community_name.trim(),
              address: this.form.address.trim(),
              status: this.form.status,
              remark: (this.form.remark || '').trim()
            })
            this.$message.success('保存成功')
          }

          this.dialogVisible = false
          this.fetchList()
        } finally {
          this.saving = false
        }
      })
    },

    onDelete(row) {
      this.$confirm(`确定删除设备【${row.device_code} - ${row.device_name}】吗？`, '删除确认', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      })
        .then(async () => {
          await deleteDevice(row.id)
          this.$message.success('删除成功')
          if (this.list.length === 1 && this.page > 1) this.page -= 1
          this.fetchList()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header{
  display:flex;
  justify-content:space-between;
  align-items:center;
}
.query-form{
  margin-bottom:10px;
}
.pager{
  margin-top:12px;
  text-align:right;
}

/* bins 区 */
.bin-wrap{
  display:flex;
  flex-wrap:wrap;
  gap:6px;
  align-items:center;
}
.bin-tag{
  cursor:pointer;
  user-select:none;
}
.bin-tag.disabled{
  cursor:not-allowed;
  opacity:.6;
}
.empty{
  color:#94a3b8;
}

/* popover */
.qr-box{
  width: 290px;
}
.qr-title{
  font-weight:700;
  margin-bottom:8px;
  line-height:1.6;
  word-break:break-word;
  white-space:normal;
}
.qr-img-wrap{
  width: 180px;
  height: 180px;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  display:flex;
  align-items:center;
  justify-content:center;
  overflow:hidden;
  background:#fff;
  margin: 0 auto;
}
.qr-img{
  width: 170px;
  height: 170px;
  cursor:pointer;
}
.qr-empty{
  color:#94a3b8;
  padding: 20px 0;
  text-align:center;
}
.qr-actions{
  margin-top:10px;
  text-align:center;
}
.qr-tip{
  margin-top:8px;
  color:#94a3b8;
  font-size:12px;
  text-align:center;
}

/* 预览弹窗 */
.preview-board{
  width: 100%;
  height: 70vh;
  padding: 8px 0 4px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.preview-title{
  font-size: 28px;
  font-weight: 700;
  line-height: 1.8;
  color: #303133;
  margin-bottom: 24px;
  word-break: break-word;
}

.preview-img-wrap{
  width: 70%;
  max-width: 620px;
  aspect-ratio: 1 / 1;
  margin: 0 auto;
  padding: 16px;
  border: 1px solid #eef2f7;
  border-radius: 12px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.preview-img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>